module.exports = __webpack_public_path__ + "65a1067db9ad0a688644193b8c1661ff.MP3";